import React from "react";

/**
 * Logo Komorotel — remplace l'ancien SVG placeholder de la Navbar.
 *
 *   <BrandLogo variant="icon" height={36} light={transparent} />
 *   <BrandLogo variant="horizontal" height={40} />
 *   <BrandLogo variant="vertical" height={180} light />
 *
 * light = true  → version blanche (header transparent sur le hero, footer sombre)
 * light = false → version couleur
 *
 * Les fichiers SVG doivent être dans public/logos/.
 */

const SRC = {
  icon:       { color: "/logos/komorotel-icon.svg",            light: "/logos/komorotel-icon-blanc.svg" },
  horizontal: { color: "/logos/komorotel-logo-horizontal.svg", light: "/logos/komorotel-logo-horizontal-blanc.svg" },
  vertical:   { color: "/logos/komorotel-logo-vertical.svg",   light: "/logos/komorotel-logo-vertical-blanc.svg" },
};

export default function BrandLogo({
  variant = "icon",
  height = 36,
  light = false,
  className = "",
  style = {},
  alt = "Komorotel",
}) {
  const src = (SRC[variant] ?? SRC.icon)[light ? "light" : "color"];

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ height, width: "auto", display: "block", ...style }}
      draggable={false}
    />
  );
}
